var EcommerceShoppingListDataSourceEnum;
(function (EcommerceShoppingListDataSourceEnum) {
    EcommerceShoppingListDataSourceEnum["default"] = "default";
    EcommerceShoppingListDataSourceEnum["disabled"] = "disabled";
    EcommerceShoppingListDataSourceEnum["shoppingListApi"] = "ShoppingListApi";
    EcommerceShoppingListDataSourceEnum["chinaShoppingListApi"] = "ChinaShoppingListApi";
    EcommerceShoppingListDataSourceEnum["iows"] = "IOWS";
    EcommerceShoppingListDataSourceEnum["mvecom"] = "MvEcom";
    EcommerceShoppingListDataSourceEnum["iksa"] = "IKSA";
})(EcommerceShoppingListDataSourceEnum || (EcommerceShoppingListDataSourceEnum = {}));
export default EcommerceShoppingListDataSourceEnum;
//# sourceMappingURL=EcommerceShoppingListDataSourceEnum.js.map